#import "~/graphql/fragments/Entry/HomeHero.graphql"
#import "~/graphql/fragments/Assets/DefaultImageAsset.graphql"

fragment DefaultCard on default_Entry {
    title

    # HEROES
    homeHero {
        ... HomeHero
    }

    defaultHero {
        ... DefaultHero
    }

    postDate

    sectionHandle

    parent {
        title
    }

    neighbourhoodRelation {
        ... on category_Entry {
            title
            slug
        }
    }

    # Card Details
    cardDetails {
        title: cardTitle
        description: cardDescription
        image: cardImage {
            ... DefaultImageAsset
        }
    }
}
